import React, { Component } from 'react'
import { Collapse } from 'react-collapse'

import './style.sass'

// Il componente che renderizza un singolo libro
export default class Collapsible extends Component {
  state = {
    isHover: false,
    isOpened: false,
  }

  handleMouseEnter = () => {
    this.setState({ isHover: true })
  }

  handleMouseLeave = () => {
    this.setState({ isHover: false })
  }

  handleClick = () => {
    this.setState({ isOpened: !this.state.isOpened })
  }

  render() {
    const {
      title,
      children,
      collapsedIcon,
      expandedIcon,
      expandedColor,
      collapsedColor,
      titlePaddingLeft,
      isOpened,
      onClick,
    } = this.props

    const { isHover } = this.state

    return (
      <div>
        <a
          className={
            'Collapsible ' +
            (isOpened || this.state.isOpened ? 'Collapsible--open' : '')
          }
          onClick={() => {
            onClick ? onClick(this.props.id) : this.handleClick()
          }}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          style={{
            paddingLeft: titlePaddingLeft ? titlePaddingLeft : 'auto',
          }}
          id={`${this.props.id}`}
        >
          <div
            className="Collapsible__Title text-bold"
            style={{
              color: isOpened || isHover ? expandedColor : collapsedColor,
            }}
          >
            {title()}
          </div>

          <div className="Collapsible__PlusIconContainer">
            {!isOpened &&
              !isHover && (
                <img src={collapsedIcon} className="Collapsible__PlusIcon" />
              )}
            {(isOpened || isHover) && (
              <img src={expandedIcon} className="Collapsible__PlusIcon" />
            )}
          </div>
        </a>
        <Collapse isOpened={isOpened || this.state.isOpened}>
          {children}
        </Collapse>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/collapsible/index.js